export const storeMap = {
  namespaced: true,

  state: {
    selectedLayerId: null,
    selectedLayerSlug: null,
    isSelectedLayerCategorical: false
  },

  actions: {
    updateSelectedLayerSlugState ({ commit }, slug) {
      commit('updateSelectedLayerSlug', slug)
    },

    updateSelectedLayerIdState ({ commit }, layerId) {
      commit('updateSelectedLayerId', layerId)
    },

    updateIsSelectedLayerCategoricalState ({ commit }, isCategorical) {
      commit('updateIsSelectedLayerCategorical', isCategorical)
    },
  },

  mutations: {
    updateSelectedLayerSlug (state, slug) {
      state.selectedLayerSlug = slug
    },

    updateSelectedLayerId (state, layerId) {
      state.selectedLayerId = layerId
    },

    updateIsSelectedLayerCategorical (state, isCategorical) {
      state.isSelectedLayerCategorical = isCategorical
    }
  },
}